module.exports = __webpack_public_path__ + "static/img/shop-style-2.eb4f85a6.png";